(function($){
  // FitText.js 1.2 - Released under the WTFPL license - http://fittextjs.com
  $.fn.fitText = function(kompressor, options){
    // Setup options
    var compressor = kompressor || 1,
        settings   = $.extend({
          minFontSize : Number.NEGATIVE_INFINITY,
          maxFontSize : Number.POSITIVE_INFINITY
        }, options);

    return this.each(function(){
      // Store object
      var $this = $(this);

      // Resizer() resizes items based on the width divided by the compressor * 10
      var resizer = function () {
        $this.css('font-size', Math.max(Math.min($this.width() / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
      };

      // Call once to set.
      resizer();

      // Recalculate on resize and orientation change
      $(window).on('resize.fittext orientationchange.fittext', resizer);
    });
  };
})(jQuery); 